import { Tooltip } from 'antd'
import AntdAvatar from 'components/Avatar'
import Pagination from 'components/Pagination'
import {
  FlexWrap,
  RowNumberData,
} from 'components/TableStyles/TableContentStyles/TableContentStyles'
import { StyledTable } from 'components/TableStyles/TableStyles'
import GreenStarIcon from 'components/icons/GreenStarIcon'
import CandidateFilter from 'modules/Roles/ViewRole/CandidatesTable/CandidateFilter'
import CandidatesStatus from 'modules/Roles/ViewRole/CandidatesTable/CandidatesStatus'
import ViewActions from 'modules/Roles/ViewRole/CandidatesTable/ViewActions'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { roleBasedDegreeListConvertion } from 'utils/roleBasedDegreeListConvertion'
import ActionRoleDrawer from '../../../../components/UIComponents/ActionRoleDrawer'
import SuccessModal from '../../../../components/UIComponents/ActionRoleDrawer/SuccessModal'
import SuccessIcon from '../../../../components/icons/SuccessIcon'
import { singlePdf, zipFile } from '../../../../utils/downloadFile'
import SelectionDisplay from '../../../Drives/ViewDriveRole/IndividualDriveTable/SelectionDisplay'

const CandidatesTable = ({
  instituteId = '',
  viewRoleDetails = false,
  setViewDrawer,
  getAppliedCandidateList,
  getCandidateDetails,
  getDegreesBasedOnRoles,
  roleBasedDegreeList,
  driveData,
  setCandidatesCount,
  setFilterDataForExport,
  setSort,
  setOrder,
  getUniqueStudentInstitutesList,
  draftData,
  selectedStudentId,
  setSelectedStudentId,
  isAllSelected,
  setIsAllSelected,
  resumeBulkDownload,
}) => {
  const { userData, corporateData } = useSelector(state => state.auth)
  const params = useParams()
  let pageLimit = 10
  const [loading, setLoading] = useState(false)
  const [campusLoading, setCampusLoading] = useState(false)
  const [candidateLoading, setCandidateLoading] = useState(false)
  const [candidatesTableData, setCandidatesTableData] = useState({})
  const [currentPage, setCurrentPage] = useState(0)
  const [searchValue, setSearchValue] = useState('')
  const [instituteSearch, setInstituteSearch] = useState('')
  const [instituteCampusList, setInstituteCampusList] = useState({
    count: 0,
    result: [],
  })
  const [checkedKeys, setCheckedKeys] = useState([])
  const [studentListId, setStudentListId] = useState([])
  const [selectedCandidateId, setSelectedCandidateId] = useState([])
  const [candidateRating, setCandidateRating] = useState({
    minValue: 0,
    maxValue: 5,
  })
  const [showSuccessPopup, setShowSuccessPopup] = useState(false)
  const [candidateStatus, setCandidateStatus] = useState([])
  const [checkedIds, setCheckedIds] = useState([])
  const [campusIds, setCampusIds] = useState([])
  const [gender, setGender] = useState('')

  const [sortBy, setSortBy] = useState('')
  const [orderBy, setOrderBy] = useState('')
  const [pageNum, setPageNum] = useState(0)
  const [rolesDegreeList, setRolesDegreeList] = useState([])
  const [count, setCount] = useState(1)
  const [actionDrawer, setActionDrawer] = useState(false)
  const [enabled, setEnabled] = useState(false)

  const [candidateFilterData, setCandidateFilterData] = useState({
    status: '',
    degreeDepartment: '',
    collegeName: '',
    gender: '',
    degreekeys: '',
  })
  const [bulkDownload, setBulkDownload] = useState(false)

  const fetchCandidateData = async () => {
    if (bulkDownload !== true) {
      setCandidateLoading(true)
    }
    const bulkStatus = bulkDownload ? true : false
    let { data, status } = await getAppliedCandidateList({
      roleId: params?.jobId,
      setLoading,
      searchValue,
      sortby: sortBy,
      orderby: orderBy,
      filterData: candidateFilterData,
      pageLimit: pageLimit,
      pageNum: pageNum,
      bulkDownload: bulkStatus,
    })

    if (status >= 200 && status < 300) {
      if (bulkDownload === true) {
        setActionDrawer(true)
        setBulkDownload(false)
        setStudentListId(data?.data?.studentIds)
      } else {
        setCandidatesTableData(data?.data)
        if (setCandidatesCount) {
          setCandidatesCount(data?.data?.count)
        }
      }
    }
    if (status >= 400) {
      setCandidatesTableData({})
      if (setCandidatesCount) {
        setCandidatesCount(0)
      }
    }
    if (setFilterDataForExport) {
      setFilterDataForExport(candidateFilterData)
    }
    if (setSort) {
      setSort(sortBy)
    }
    if (setOrder) {
      setOrder(orderBy)
    }
    setCandidateLoading(false)
  }
  useEffect(() => {
    if (instituteId != '') {
      setCandidateFilterData({
        ...candidateFilterData,
        collegeName: instituteId,
      })
    }
  }, [instituteId])

  useEffect(() => {
    setPageNum(0)
    setCount(prev => prev + 1)
  }, [candidateFilterData, searchValue])

  useEffect(() => {
    if (bulkDownload === true) {
      fetchCandidateData()
    }
  }, [bulkDownload])
  useEffect(() => {
    if (isAllSelected) {
      const allIds = candidatesTableData?.result?.map(p => p.student.id) || []
      setSelectedCandidateId(allIds)
    } else {
      setSelectedCandidateId([])
    }
  }, [isAllSelected, candidatesTableData])

  useEffect(() => {
    let getData
    if (searchValue) {
      getData = setTimeout(() => {
        let hasViewRole
        hasViewRole = Object?.values(params)?.some(value =>
          value?.includes('view-college-details')
        )

        if (hasViewRole) {
          if (instituteId !== '' && candidateFilterData?.collegeName) {
            fetchCandidateData()
          }
        } else {
          fetchCandidateData()
        }
      }, 500)
    } else {
      getData = setTimeout(() => {
        fetchCandidateData()
      }, 500)
    }
    return () => clearTimeout(getData)
  }, [sortBy, orderBy, pageNum, count, candidateFilterData])

  const loadMoreData = async () => {
    let response = await getUniqueStudentInstitutesList({
      pageNum: instituteSearch ? 0 : currentPage,
      limit: 50,
      searchValue: instituteSearch,
      setLoading: setCampusLoading,
      forFilter: true,
    })

    if (response?.status >= 200 && response?.status <= 300) {
      let { count, result } = response?.data?.data || {}
      if (instituteSearch == '') {
        setInstituteCampusList({
          count,
          result: [...(instituteCampusList?.result || []), ...result],
        })

        setCurrentPage(currentPage + 1)
      } else {
        setInstituteCampusList({
          count,
          result,
        })
        setCurrentPage(0)
      }
    }
  }
  const closePopup = () => {
    setShowSuccessPopup(false)
  }
  useEffect(() => {
    if (getUniqueStudentInstitutesList) {
      loadMoreData()
    }
  }, [])

  useEffect(() => {
    const getData = setTimeout(() => {
      setInstituteCampusList({
        count: 0,
        result: [],
      })
      if (getUniqueStudentInstitutesList) {
        loadMoreData()
      }
    }, 500)

    return () => clearTimeout(getData)
  }, [instituteSearch])

  useEffect(() => {
    getDegreesBasedOnRoles({ jobId: params?.jobId })
  }, [params?.jobId])

  useEffect(() => {
    const updatedData = roleBasedDegreeListConvertion({
      listOfDegree: roleBasedDegreeList,
      parentNameParam: 'degree',
      parentValueParam: 'degreeId',
      pathName: 'streams',
      childrenValueParam: 'degreeStreamMapId',
    })
    setRolesDegreeList(updatedData)
  }, [roleBasedDegreeList])

  const studentDetailsAPI = async std_Id => {
    const { status } = await getCandidateDetails({
      studentId: std_Id,
      roleId: params?.jobId,
      setLoading: setCandidateLoading,
    })

    if (status >= 200 && status < 300) {
      setViewDrawer(true)
    }
  }

  const pastCourseDetails = student => {
    if (student?.isExpCandidate) {
      return student?.educationProfile?.map(
        education => `${education?.degree} - ${education?.department}`
      )
    } else {
      return `${
        student?.currentCourse?.shortForm
          ? student?.currentCourse?.shortForm
          : student?.currentCourse?.degree
      } - ${student?.currentCourse?.department}`
    }
  }
  const pastCourseCollegeName = student => {
    if (student?.isExpCandidate) {
      return student?.educationProfile?.map(education => {
        const institutionName = education?.institutionName
        return institutionName?.length > 16
          ? `${institutionName?.substr(0, 16)}...`
          : institutionName
      })
    } else {
      return student?.instituteCampusName?.length > 16
        ? student?.instituteCampusName?.substr(0, 16) + '...'
        : student?.instituteCampusName
    }
  }
  const rowSelection = {
    selectedRowKeys: selectedCandidateId,
    onChange: selectedRowKeys => {
      setSelectedCandidateId(selectedRowKeys)
      setEnabled(selectedRowKeys.length > 0)
      setIsAllSelected(false)
    },
    preserveSelectedRowKeys: true,
    getCheckboxProps: record => ({
      // You can also enable/disable based on `isAllSelected` here
      // but this only controls the individual checkbox, not the global "select all"
    }),
  }
  const handleClearAllClick = () => {
    setIsAllSelected(false)
    setEnabled(false)
  }

  const enableSelectAll = candidatesTableData?.count > 10

  const handleSelectAllClick = () => {
    setIsAllSelected(true)
    setSelectedCandidateId([])
  }
  const handleResumeDownloadClick = async () => {
    if (selectedCandidateId.length <= 10 && !isAllSelected) {
      setActionDrawer(true)
    } else {
      setBulkDownload(true)
    }
  }

  const columns = [
    {
      title: 'candidate Name',
      dataIndex: 'firstName',
      sorter: true,
      render: (_, { student }) => (
        <FlexWrap alignCenter gap="8px">
          <AntdAvatar
            src={student?.profileUrl}
            size={25}
            IconName={student?.firstName?.split('')[0]}
          />
          <RowNumberData>
            {student?.firstName?.length > 16
              ? student?.firstName?.substr(0, 16) + '...'
              : student?.firstName}
          </RowNumberData>
        </FlexWrap>
      ),
    },
    {
      title: 'College Name',
      dataIndex: 'instituteCampusName',
      sorter: true,
      render: (_, { student }) => (
        <RowNumberData>
          <Tooltip title={student?.instituteCampusName}>
            {pastCourseCollegeName(student)}
          </Tooltip>
        </RowNumberData>
      ),
    },
    {
      title: 'Location',
      dataIndex: 'corrCity',
      sorter: true,
      render: (_, { student }) => (
        <RowNumberData>
          {student?.studentPersonalProfile?.corrCity ??
            student?.studentPersonalProfile?.[0]?.corrCity}
        </RowNumberData>
      ),
    },
    {
      title: 'Deg & Department',
      dataIndex: 'degree',
      sorter: true,
      width: 200,
      render: (_, { student }) => (
        <RowNumberData>{pastCourseDetails(student)}</RowNumberData>
      ),
    },
    // {
    //   title: 'Candidate Rating',
    //   dataIndex: 'rating',
    //   sorter: true,
    //   hidden: !draftData?.isRankingActive,
    //   render: rating => (
    //     <FlexWrap gap="5px">
    //       <RowNumberData>{Number(rating)?.toFixed(2)}</RowNumberData>
    //       <AntdAvatar
    //         size={22}
    //         IconName={<GreenStarIcon />}
    //         background="none"
    //       />
    //     </FlexWrap>
    //   ),
    // },
    {
      title: 'Status',
      dataIndex: 'driveRoleCandidateMap',
      render: data => <CandidatesStatus status={data[0]?.status} />,
    },

    {
      title: 'Action',
      render: (_, { student }) => (
        <ViewActions
          driveData={driveData}
          key={student?.id}
          student_id={student?.id}
          candidateLoading={candidateLoading}
          studentDetailsAPI={studentDetailsAPI}
        />
      ),
    },
  ].filter(item => !item.hidden)

  const selectedInstiteIdsColumns = [
    {
      title: 'candidate Name',
      dataIndex: 'firstName',
      sorter: true,
      render: (_, { student }) => (
        <FlexWrap alignCenter gap="8px">
          <AntdAvatar
            src={student?.profileUrl}
            size={25}
            IconName={student?.firstName?.split('')[0]}
          />
          <RowNumberData>
            {student?.firstName?.length > 16
              ? student?.firstName?.substr(0, 16) + '...'
              : student?.firstName}
          </RowNumberData>
        </FlexWrap>
      ),
    },
    {
      title: 'Gender',
      dataIndex: 'gender',
      sorter: true,
      render: (_, { student }) => (
        <RowNumberData>
          {student?.studentPersonalProfile?.gender
            ? student?.studentPersonalProfile?.gender
            : '-'}
        </RowNumberData>
      ),
    },
    {
      title: 'Deg & Department',
      dataIndex: 'degree',
      sorter: true,
      width: 200,
      render: (_, { student }) => (
        <RowNumberData>
          {`${
            student?.currentCourse?.shortForm
              ? student?.currentCourse?.shortForm
              : student?.currentCourse?.degree
          } - ${student?.currentCourse?.department}`}
        </RowNumberData>
      ),
    },
    // {
    //   title: 'Score',
    //   dataIndex: 'rating',
    //   sorter: true,
    //   hidden: !draftData?.isRankingActive,
    //   render: rating => (
    //     <FlexWrap gap="5px">
    //       <RowNumberData>{Number(rating)?.toFixed(2)}</RowNumberData>
    //       <AntdAvatar
    //         size={22}
    //         IconName={<GreenStarIcon />}
    //         background="none"
    //       />
    //     </FlexWrap>
    //   ),
    // },
    {
      title: 'STAGE',
      dataIndex: 'stage',
      render: (_, { driveRoleCandidateMap }) => (
        <RowNumberData>
          {driveRoleCandidateMap[0]?.stage
            ? driveRoleCandidateMap[0]?.stage
            : '-'}
        </RowNumberData>
      ),
    },
    {
      title: 'Status',
      dataIndex: 'driveRoleCandidateMap',
      render: (_, { driveRoleCandidateMap }) => (
        <CandidatesStatus
          status={
            driveRoleCandidateMap[0]?.status
              ? driveRoleCandidateMap[0]?.status
              : '-'
          }
        />
      ),
    },

    {
      title: 'Action',
      render: (_, { student }) => (
        <ViewActions
          driveData={driveData}
          key={student?.id}
          student_id={student?.id}
          candidateLoading={candidateLoading}
          studentDetailsAPI={studentDetailsAPI}
          roleId={params?.jobId}
        />
      ),
    },
  ].filter(item => !item.hidden)

  const handleSort = (page, search, filter) => {
    if (filter?.order) {
      let sort = filter?.order == 'ascend' ? 'asc' : 'desc'
      setSortBy(filter?.field)
      setOrderBy(sort)
    } else {
      setOrderBy('')
      setSortBy('')
    }
  }

  const onPageChange = value => {
    setPageNum(value)
  }
  const candidateDetailsCount = {
    notDisabledCount: candidatesTableData?.count,
  }
  const handleApprove = async () => {
    setEnabled(false)
    setActionDrawer(false)
    setBulkDownload(false)
    setIsAllSelected(false)
    let payload = {
      email: userData.email,
      instName: corporateData.name,
      state: corporateData.state,
      city: corporateData.city,
      user: userData.first_name + ' ' + userData.last_name,
      studentIds:
        isAllSelected === true ? studentListId : [selectedCandidateId],
      roleId: params?.jobId,  
    }

    if (payload.studentIds[0].length > 5) {
      setShowSuccessPopup(true)
    }
    setSelectedCandidateId([])
    const response = await resumeBulkDownload(payload)
    if (response?.data) {
      if (payload?.studentIds[0]?.length === 1) {
        const studentData = candidatesTableData?.result.find(
          p => p.student.id === payload.studentIds[0][0]
        )
        const studentName =
          (studentData?.student?.firstName || '') +
          ' ' +
          (studentData?.student?.lastName || '')
        await singlePdf(response, studentName)
      } else if (payload?.studentIds[0]?.length <= 5) {
        await zipFile(response.data)
      }
    }
    setStudentListId([])
  }

  const handleClose = async () => {
    setActionDrawer(false)
    setBulkDownload(false)
  }

  return (
    <>
      <CandidateFilter
        draftData={draftData}
        appliedCandidatesList={candidatesTableData}
        searchValue={searchValue}
        setSearchValue={setSearchValue}
        candidateRating={candidateRating}
        setCandidateRating={setCandidateRating}
        candidateStatus={candidateStatus}
        setCandidateStatus={setCandidateStatus}
        gender={gender}
        setGender={setGender}
        instituteSearch={instituteSearch}
        setInstituteSearch={setInstituteSearch}
        degreeListData={rolesDegreeList}
        checkedKeys={checkedKeys}
        setCheckedKeys={setCheckedKeys}
        checkedIds={checkedIds}
        setCheckedIds={setCheckedIds}
        institutesList={instituteCampusList}
        loadMoreData={loadMoreData}
        campusIds={campusIds}
        setCampusIds={setCampusIds}
        candidateFilterData={candidateFilterData}
        setCandidateFilterData={setCandidateFilterData}
        viewRoleDetails={viewRoleDetails}
        campusLoading={campusLoading}
        instituteId={instituteId}
        handleResumeDownloadClick={handleResumeDownloadClick}
        selectedStudentId={selectedCandidateId}
      />
      {candidatesTableData?.count > 10 && enabled && (
        <div style={{ marginLeft: '15px' }}>
          <SelectionDisplay
            wholeSelect={false}
            selectedCandidate={selectedCandidateId}
            candidateDeatils={candidateDetailsCount}
            isAllSelected={isAllSelected}
            handleSelectAllClick={handleSelectAllClick}
            handleClearAllClick={handleClearAllClick}
            enableSelectAll={enableSelectAll}
          />
        </div>
      )}
      <StyledTable
        rowSelection={rowSelection}
        columns={viewRoleDetails ? selectedInstiteIdsColumns : columns}
        loading={loading}
        dataSource={candidatesTableData?.result}
        onChange={handleSort}
        rowKey={record => record?.student?.id}
        pagination={false}
      />

      {candidatesTableData?.count > 0 && (
        <Pagination
          onChange={onPageChange}
          totalPages={candidatesTableData?.totalPage * 10}
          pageSize={pageLimit}
          current={pageNum || pageNum + 1}
        />
      )}
      <ActionRoleDrawer
        description="Are you sure you want to download all selected resumes?"
        closeText="No"
        YesText="Yes"
        showDrawer={actionDrawer}
        setShowDrawer={setActionDrawer}
        onApprove={handleApprove}
        onCloseClick={handleClose}
      />
      <SuccessModal
        description={
          <div>
            Your request is being processed. Please check your email inbox
            shortly for the download link.
          </div>
        }
        Icon={SuccessIcon}
        showDrawer={showSuccessPopup}
        setShowDrawer={setShowSuccessPopup}
        onCloseClick={closePopup}
      />
    </>
  )
}

export default CandidatesTable
